module.exports = __webpack_public_path__ + "img/logo.c64e8bca.png";